var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAssistantRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RobotLayer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 751.68 637.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .failure-cls-1{fill:#ebebeb;}.failure-cls-2{fill:#202b30;}.failure-cls-3{fill:#36bdb9;}.failure-cls-11,.failure-cls-4{fill:#fff;}.failure-cls-10,.failure-cls-4{opacity:0.4;}.failure-cls-5{fill:#25aaaa;}.failure-cls-6,.failure-cls-8{fill:#010101;}.failure-cls-6{opacity:0.2;}.failure-cls-7{fill:#dcdbdb;}.failure-cls-13,.failure-cls-8{opacity:0.1;}.failure-cls-9{fill:#263238;}.failure-cls-12{fill:#f7b319;}.failure-cls-13{fill:none;stroke:#010101;stroke-miterlimit:10;stroke-width:4px;}.failure-cls-14{fill:#455b64;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M665.23,710.12l13-21-6.44-4a5.86,5.86,0,0,1-2.73-5.53c.1-1.23.14-2.46.12-3.7a5.87,5.87,0,0,1,3.07-5.34L679,667l-11.7-21.81-6.67,3.58a5.88,5.88,0,0,1-6.15-.4,33,33,0,0,0-3.15-2A5.87,5.87,0,0,1,648.2,641l.24-7.57-24.74-.77-.23,7.6a5.87,5.87,0,0,1-3.44,5.12c-.55.26-1.09.53-1.63.82s-1.07.59-1.59.9a5.85,5.85,0,0,1-6.14,0l-6.49-4-13,21,6.45,4a5.88,5.88,0,0,1,2.73,5.54,32.35,32.35,0,0,0-.12,3.69,5.9,5.9,0,0,1-3.07,5.33l-6.68,3.58,11.7,21.81,6.68-3.58a5.87,5.87,0,0,1,6.14.4,33.75,33.75,0,0,0,3.13,1.93,5.88,5.88,0,0,1,3.11,5.34l-.24,7.59,24.74.77.23-7.6a5.88,5.88,0,0,1,3.44-5.1c.55-.26,1.1-.53,1.64-.82s1.07-.59,1.59-.91a5.88,5.88,0,0,1,6.17,0Zm-21-15.62a20.26,20.26,0,1,1,8.3-27.44A20.24,20.24,0,0,1,644.28,694.5Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M336,332.24l-33,.28-16.6.11-16.63.06h-.45v-.45l-.05-28v-.5h.5l33.12.06L336,304h.27v.27Zm0,0-.28-28,.28.27-33.12.17-33.12.06.5-.5-.06,28-.44-.45,16.48.06,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M265.12,332.24l-33,.28-16.6.11-16.63.06h-.45v-.45l-.05-28v-.5h.5l33.12.06,33.12.17h.27v.27Zm0,0-.28-28,.28.27-33.12.17-33.12.06.5-.5-.06,28-.44-.45,16.48.06,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M779.34,475.81l-16.56.2-16.56.14-16.56.09-16.56,0h-.47v-.47q0-14,0-28v-.47h.47l16.56,0,16.56.1,16.56.13,16.56.2-16.56.2-16.56.14-16.56.09-16.56,0,.47-.47q0,14,0,28l-.47-.47,16.56,0,16.56.1,16.56.13Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M708.44,475.81l-33,.28-16.6.11-16.63.06h-.45v-.45l0-28v-.5h.5l33.12.07,33.12.16h.27v.27Zm0,0-.27-28,.27.28-33.12.16-33.12.06.5-.5-.05,28-.45-.44,16.48.05,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M321.48,496l-33,.28-16.6.11-16.64,0h-.44V496l-.06-28v-.5h.5l33.12.06,33.12.16h.28V468Zm0,0-.27-28,.27.27-33.12.16-33.12.07.5-.5-.05,28-.45-.45,16.49.06,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M826.68,230.58l-33,.28-16.6.11-16.64.05H760v-.44l-.06-28v-.5h.5l33.12.06,33.12.16H827v.28Zm0,0-.27-28,.27.27-33.12.16-33.12.07.5-.5-.05,28-.45-.45,16.49.06,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-1",
    d: "M789.73,265.87l-33,.28-16.6.11-16.64.06h-.44v-.45l-.06-28v-.5h.5l33.12.06,33.12.17H790v.27Zm0,0-.27-28,.27.27-33.12.17-33.12.06.5-.5,0,28-.45-.44,16.49.05,16.52.11Z",
    transform: "translate(-145.48 -176.71)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "robot-2",
    "data-name": "robot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RobotLayer_2",
    "data-name": "Robot Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "failure-cls-1",
    cx: 372.23,
    cy: 590.68,
    rx: 330.25,
    ry: 46.69
  })), /*#__PURE__*/React.createElement("g", {
    id: "RobotLayer",
    "data-name": "Robot Layer"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-2",
    x: 292.97,
    y: 517.9,
    width: 149.59,
    height: 40.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-2",
    x: 326.51,
    y: 314.35,
    width: 79.2,
    height: 34.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-3",
    x: 633.56,
    y: 682.98,
    width: 12.68,
    height: 108.52,
    transform: "translate(-316.55 1103.97) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-4",
    x: 633.56,
    y: 682.98,
    width: 12.68,
    height: 108.52,
    transform: "translate(-316.55 1103.97) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-3",
    x: 633.3,
    y: 730.42,
    width: 18.83,
    height: 12.68,
    transform: "translate(-320.99 1095.2) rotate(-82.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-3",
    points: "551.32 590.93 558.13 472.02 635.56 478.74 620.95 595.46 551.32 590.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-5",
    points: "532.64 588.15 551.32 590.93 558.13 472.02 533.72 482.44 532.64 588.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-3",
    points: "422.94 560.03 450.73 563.92 453.46 545.45 425.68 541.55 422.94 560.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-3",
    x: 334.04,
    y: 730.9,
    width: 108.52,
    height: 12.68,
    transform: "translate(-233.99 -122.81) rotate(-7.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-4",
    x: 334.04,
    y: 730.9,
    width: 108.52,
    height: 12.68,
    transform: "translate(-233.99 -122.81) rotate(-7.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-3",
    x: 379.14,
    y: 727.34,
    width: 12.68,
    height: 18.83,
    transform: "translate(-243.24 -116.62) rotate(-7.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-3",
    points: "185.91 590.93 179.11 472.02 101.68 478.74 116.29 595.46 185.91 590.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-5",
    points: "204.6 588.15 185.91 590.93 179.11 472.02 203.52 482.44 204.6 588.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-3",
    points: "314.3 560.03 286.51 563.92 283.77 545.45 311.56 541.55 314.3 560.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M357.17,589.45c-.33-.3-33.69-31.24-72.93-20.66-40.13,10.83-73.26,71.27-73.59,71.88l-11.15-6c1.45-2.68,36-65.86,81.44-78.09,46.21-12.46,83.4,22.23,85,23.71Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-4",
    d: "M357.17,589.45c-.33-.3-33.69-31.24-72.93-20.66-40.13,10.83-73.26,71.27-73.59,71.88l-11.15-6c1.45-2.68,36-65.86,81.44-78.09,46.21-12.46,83.4,22.23,85,23.71Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M225.44,701.52l-24-12.69c2.3-4.37,5.14-11.87,5.56-18.65.53-8.78-2.95-11.87-6.8-13.9-8.42-4.45-13.44-2.69-16.88-.66-4.81,2.84-9.71,8.66-13.78,16.37l-24-12.68c6.58-12.46,14.65-21.57,24-27.09s24.43-10,43.38,0c14.77,7.8,22.31,21.85,21.23,39.58C233.24,685.78,227.25,698.08,225.44,701.52Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M398.83,631.23c-.06-.57-19.35-4.35-19.35-4.35l-12.85-73.71,22.63-10.58Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M402.29,630.58c-.06-.58-22.81-3.7-22.81-3.7l-12.64-73.75,27.22-11.45Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M641.88,522s-193.17-8.23-258.42,2.61c0,0,19.16,186.2,20.19,189.81,0,0,192.16-.51,222.2,0C625.85,714.39,642.13,590.58,641.88,522Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M580.22,573.44s-100.13-4-134,1.26c0,0,9.93,89.49,10.47,91.23,0,0,99.6-.25,115.17,0C571.91,665.93,578.76,604.68,580.22,573.44Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M461.65,666.42c-2.29,0-4.11,0-5.38.05,0,0-6.83-61.27-8.31-92.5l6.25-.22Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-4",
    d: "M537,595.53a10.65,10.65,0,1,1-7,13.36A10.65,10.65,0,0,1,537,595.53Zm-5.71,13a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Zm5.71-13a10.65,10.65,0,1,1-7,13.36A10.65,10.65,0,0,1,537,595.53Zm-5.71,13a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Zm5.71-13a10.65,10.65,0,1,1-7,13.36A10.65,10.65,0,0,1,537,595.53Zm-5.71,13a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Zm2.16-24.21a22.45,22.45,0,1,1-14.65,28.15A22.44,22.44,0,0,1,533.45,584.28Zm-5,25.1a12.3,12.3,0,1,0,8-15.43A12.31,12.31,0,0,0,528.47,609.38Zm1.58-.49a10.65,10.65,0,1,1,13.35,7A10.64,10.64,0,0,1,530.05,608.89Zm1.24-.4a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Zm5.71-13a10.65,10.65,0,1,1-7,13.36A10.65,10.65,0,0,1,537,595.53Zm-5.71,13a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Zm5.71-13a10.65,10.65,0,1,1-7,13.36A10.65,10.65,0,0,1,537,595.53Zm-5.71,13a9.35,9.35,0,1,0,6.1-11.72A9.34,9.34,0,0,0,531.29,608.49Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "397.07 450.79 405.31 448.2 406.69 454.17 399.37 456.48 397.07 450.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "411.87 443.08 415.86 435.43 421.06 438.67 417.51 445.48 411.87 443.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "416.88 427.17 414.29 418.94 420.26 417.55 422.56 424.88 416.88 427.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "409.17 412.37 401.51 408.39 404.76 403.19 411.57 406.73 409.17 412.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "393.25 407.36 385.02 409.96 383.64 403.99 390.96 401.68 393.25 407.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "378.46 415.07 374.47 422.73 369.27 419.48 372.82 412.68 378.46 415.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "373.45 430.99 376.05 439.22 370.07 440.6 367.77 433.28 373.45 430.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-4",
    points: "381.16 445.78 388.82 449.77 385.57 454.97 378.76 451.42 381.16 445.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-7",
    d: "M500.8,626.85a7.17,7.17,0,1,1-2.09,9.92A7.17,7.17,0,0,1,500.8,626.85Zm-1.36,9.45a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Zm1.36-9.45a7.17,7.17,0,1,1-2.09,9.92A7.17,7.17,0,0,1,500.8,626.85Zm-1.36,9.45a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Zm1.36-9.45a7.17,7.17,0,1,1-2.09,9.92A7.17,7.17,0,0,1,500.8,626.85Zm-1.36,9.45a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Zm-3-16.1a15.12,15.12,0,1,1-4.41,20.91A15.12,15.12,0,0,1,496.46,620.2Zm1.31,17.18a8.28,8.28,0,1,0,2.42-11.46A8.29,8.29,0,0,0,497.77,637.38Zm.94-.61a7.17,7.17,0,1,1,9.91,2.1A7.17,7.17,0,0,1,498.71,636.77Zm.73-.47a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Zm1.36-9.45a7.17,7.17,0,1,1-2.09,9.92A7.17,7.17,0,0,1,500.8,626.85Zm-1.36,9.45a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Zm1.36-9.45a7.17,7.17,0,1,1-2.09,9.92A7.17,7.17,0,0,1,500.8,626.85Zm-1.36,9.45a6.29,6.29,0,1,0,1.83-8.71A6.29,6.29,0,0,0,499.44,636.3Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "364.7 469.88 369.57 466.7 371.55 470.33 367.21 473.15 364.7 469.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "372.9 462.2 374.1 456.51 378.06 457.68 376.99 462.74 372.9 462.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "373.27 450.97 370.1 446.1 373.72 444.13 376.54 448.46 373.27 450.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "365.6 442.77 359.91 441.57 361.08 437.62 366.13 438.68 365.6 442.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "354.37 442.4 349.5 445.57 347.53 441.95 351.86 439.13 354.37 442.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "346.17 450.08 344.97 455.76 341.01 454.6 342.08 449.54 346.17 450.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "345.8 461.3 348.97 466.17 345.35 468.15 342.53 463.82 345.8 461.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-7",
    points: "353.48 469.5 359.16 470.71 358 474.66 352.94 473.6 353.48 469.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-3",
    points: "255.92 508.97 248.94 510.96 230.27 374.23 238.3 372.75 255.92 508.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M455.94,665.33l-9.07-91.23-63.09-24.64s18.68,139,18.68,137.51Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-4",
    d: "M456.74,665.93,446.27,574.7l-62.49-25.24s16,138.18,16,136.71Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-8",
    points: "451.55 348.47 450.36 371.29 449.34 394.11 447.58 439.77 446.21 485.44 445.66 508.29 445.28 531.13 446.47 508.31 447.49 485.49 449.24 439.83 450.62 394.16 451.17 371.31 451.55 348.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M603.56,538.93a4.32,4.32,0,0,0,3,5,4.3,4.3,0,1,0,1.69-8.4A4.31,4.31,0,0,0,603.56,538.93Zm0,0a3.45,3.45,0,0,1,4.48-2.61,3.48,3.48,0,0,1-1.37,6.76,3.52,3.52,0,0,1-2.44-1.3A3.56,3.56,0,0,1,603.56,538.93Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M600,617.73a4.31,4.31,0,0,0,2.94,5,4.31,4.31,0,1,0,1.7-8.4A4.29,4.29,0,0,0,600,617.73Zm0,0a3.43,3.43,0,0,1,4.47-2.61,3.48,3.48,0,0,1-1.36,6.76,3.54,3.54,0,0,1-2.45-1.3A3.6,3.6,0,0,1,600,617.73Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M598,682.47a4.32,4.32,0,0,0,3,5,4.42,4.42,0,0,0,3.38-.38,4.3,4.3,0,0,0-1.69-8A4.32,4.32,0,0,0,598,682.47Zm0,0a3.46,3.46,0,0,1,4.48-2.62,3.48,3.48,0,0,1-1.37,6.77,3.46,3.46,0,0,1-3.11-4.15Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M320,526.93c-5.45-3.19-10.91-6.37-16.45-9.4L295.25,513c-2.81-1.44-5.59-2.95-8.44-4.34,2.6,1.82,5.26,3.51,7.89,5.28l8,5.07c5.34,3.38,10.77,6.61,16.19,9.84s10.91,6.36,16.46,9.39,11.08,6.07,16.75,8.88c-5.21-3.6-10.54-7-15.89-10.34",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M365.9,599c-7.46,4.25-14.53,9-21.5,14s-13.77,10.1-20.22,15.78c7.46-4.25,14.53-9.05,21.5-14S359.45,604.63,365.9,599Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M353.65,592.58c-5.76,1.75-11.42,3.73-17.08,5.74s-11.26,4.13-16.86,6.28S308.55,609,303,611.36l-8.27,3.55c-2.73,1.26-5.48,2.45-8.19,3.77,2.89-.85,5.72-1.84,8.58-2.75l8.5-3c5.66-2,11.26-4.13,16.86-6.29s11.16-4.4,16.68-6.76S348.23,595.18,353.65,592.58Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M337.3,552c-5.52-1.44-11.08-2.63-16.64-3.79S309.51,546,303.92,545s-11.2-1.92-16.83-2.7l-8.45-1.18c-2.83-.31-5.65-.69-8.49-.94,2.76.74,5.54,1.34,8.3,2l8.34,1.78c5.56,1.19,11.15,2.2,16.74,3.21s11.2,1.91,16.83,2.69S331.62,551.44,337.3,552Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M654.59,574.56c16,0,51.1,3.61,73.67,32.63,28.88,37.13,107.9-13.86,107.44-10.84l6.39,11.16c.1-.68-84.55,51.85-123.84,7.46-26.94-30.43-70.21-27.47-70.67-27.42L646.16,575A77.48,77.48,0,0,1,654.59,574.56Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "failure-cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-11",
    d: "M654.59,574.56c16,0,51.1,3.61,73.67,32.63,28.88,37.13,107.9-13.86,107.44-10.84l6.39,11.16c.1-.68-84.55,51.85-123.84,7.46-26.94-30.43-70.21-27.47-70.67-27.42L646.16,575A77.48,77.48,0,0,1,654.59,574.56Z",
    transform: "translate(-145.48 -176.71)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M822.91,596.82a42.84,42.84,0,0,0,3,6.37c10.52,18.67,25.63,23.09,36.45,23.51s22.58-2.87,34.85-9.79l-13.34-23.67c-7.6,4.28-14.87,6.52-20.45,6.31-4-.16-9.16-1.4-13.83-9.7-2.14-3.79-3.4-8.27,1.81-15.36,4-5.48,10.46-10.25,14.77-12.68l-13.34-23.67c-3.39,1.91-15.08,9-23.34,20.28C820.45,570.67,818.22,584.09,822.91,596.82Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M626.5,630.44c0-.57,22.72-4.2,22.72-4.2l11-74-27.47-10.85Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M626.5,630.44c0-.57,22.72-4.2,22.72-4.2l11-74-27.47-10.85Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M362.94,544.27c-7.53-5.59-14.22-11.43-20.91-17.26-6.45-5.91-12.87-11.83-18.47-18",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M366.48,610.14c-2.13,5.32-4.54,10.32-7,15.32s-5,9.79-7.78,14.37",
    transform: "translate(-145.48 -176.71)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M658.73,446c0-.88,28.26-10.36,28.26-10.36L691.42,323l-36.22-11.3Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M658.73,446c0-.88,28.26-10.36,28.26-10.36L691.42,323l-36.22-11.3Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M360.62,473.37c-.2-.85-28.52-3.66-28.52-3.66L300.53,361.46l30.54-19.13Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-6",
    d: "M360.62,473.37c-.2-.85-28.52-3.66-28.52-3.66L300.53,361.46l30.54-19.13Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-3",
    d: "M664.77,487.88s-2.35-182.73-9.78-243.2c0,0-220.84,4.79-342,43.78,0,0,49.76,216,52.36,226.7C365.33,515.16,521.86,493,664.77,487.88Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "failure-cls-6",
    cx: 586.82,
    cy: 392.21,
    r: 62.55,
    transform: "translate(-250.94 353.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "failure-cls-2",
    cx: 586.82,
    cy: 392.21,
    r: 50.16,
    transform: "translate(-236.78 19.7) rotate(-17.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 591.44,
    y: 373.32,
    width: 11.88,
    height: 11.88,
    transform: "translate(1086.32 515.95) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 601.99,
    y: 360.24,
    width: 11.88,
    height: 11.88,
    transform: "translate(1105.96 488.75) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 554.74,
    y: 365.31,
    width: 11.88,
    height: 11.88,
    transform: "translate(1012.27 503.89) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 607.03,
    y: 407.23,
    width: 11.88,
    height: 11.88,
    transform: "translate(1121.02 581.91) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 559.78,
    y: 412.29,
    width: 11.88,
    height: 11.88,
    transform: "translate(1027.33 597.05) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 593.95,
    y: 396.68,
    width: 11.88,
    height: 11.88,
    transform: "translate(1093.81 562.27) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 580.88,
    y: 386.27,
    width: 11.88,
    height: 11.88,
    transform: "translate(1066.64 542.9) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 567.82,
    y: 375.85,
    width: 11.88,
    height: 11.88,
    transform: "translate(1039.48 523.52) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 570.32,
    y: 399.21,
    width: 11.88,
    height: 11.88,
    transform: "translate(1046.97 569.83) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "failure-cls-2",
    cx: 417.81,
    cy: 409.36,
    r: 50.16,
    transform: "translate(-277.92 431.05) rotate(-64.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "failure-cls-12",
    x: 411.87,
    y: 379.79,
    width: 11.88,
    height: 59.13,
    transform: "translate(756.53 560.81) rotate(169.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M480.16,259.65q3.6,33.18,7.4,66.32l7.8,66.27.67-.89-.67.89h0l.95.71h0l.76-.14-.1-.76-8.2-66.22Q484.62,292.73,480.16,259.65Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M487.57,285.88a4.33,4.33,0,0,0,3.64,4.48,4.31,4.31,0,1,0,.46-8.56A4.33,4.33,0,0,0,487.57,285.88Zm0,0a3.58,3.58,0,0,1,1.36-2.59,3.53,3.53,0,0,1,2.69-.65,3.48,3.48,0,0,1-.37,6.89,3.53,3.53,0,0,1-2.61-.94A3.57,3.57,0,0,1,487.57,285.88Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M493.19,328.76a4.32,4.32,0,0,0,3.64,4.49,4.31,4.31,0,1,0,.46-8.56A4.32,4.32,0,0,0,493.19,328.76Zm0,0a3.58,3.58,0,0,1,1.36-2.58,3.47,3.47,0,1,1-.29,5.3A3.58,3.58,0,0,1,493.19,328.76Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-8",
    d: "M499.62,373.23a4.33,4.33,0,0,0,3.64,4.49,4.31,4.31,0,0,0,3.64-7.34,4.29,4.29,0,0,0-7.28,2.85Zm0,0a3.58,3.58,0,0,1,1.36-2.58,3.47,3.47,0,1,1,2.32,6.24,3.47,3.47,0,0,1-3.68-3.66Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "failure-cls-13",
    x1: 343.5,
    y1: 283.1,
    x2: 379.32,
    y2: 277.78
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "failure-cls-11",
    points: "505.59 76.41 462.47 80.21 462.45 78.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "failure-cls-11",
    points: "419.42 81.17 462.7 80.15 462.51 78.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "failure-cls-11",
    points: "334.53 346.17 291.24 346.63 291.4 348.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "failure-cls-11",
    points: "248.31 349.91 291.47 346.67 291.47 348.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-11",
    d: "M336,369.93c-1.81-6.46-3.39-13-5.09-19.44s-3.22-13-4.74-19.51-3-13-4.51-19.56-2.87-13.06-4.31-19.6l-.38-1.74,1.72-.51q20.81-6.17,41.81-11.51,10.5-2.67,21.08-5.06c7.08-1.49,14.14-3.07,21.27-4.29l-41.53,12.34-41.53,12.22,1.34-2.25c1.35,6.55,2.77,13.09,4.07,19.65s2.63,13.12,3.87,19.7,2.46,13.15,3.63,19.74S335,363.3,336,369.93Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-11",
    d: "M642.28,382.37a54.74,54.74,0,0,0-8.87-22.84c-1.14-1.73-2.45-3.35-3.7-5s-2.8-3.08-4.21-4.62c-1.55-1.39-3.12-2.78-4.71-4.13s-3.39-2.46-5.13-3.62c-1.85-1-3.67-2-5.54-3l-5.83-2.35-6.08-1.58c-2-.41-4.14-.58-6.2-.84a60.31,60.31,0,0,0-24.28,3.4c8.08-1.09,16.1-1.53,23.93-.38a56.22,56.22,0,0,1,21.94,8A65.13,65.13,0,0,1,631,361.3,73.82,73.82,0,0,1,642.28,382.37Z",
    transform: "translate(-145.48 -176.71)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "broken"
  }, /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M560.19,581.26a62.25,62.25,0,0,1,4.52-13,52.74,52.74,0,0,1,7.4-11.58,27.9,27.9,0,0,1,11-8.14,19,19,0,0,1,13.68.21,18.28,18.28,0,0,1,9.68,9.69,21.75,21.75,0,0,1,1.82,6.73,14.84,14.84,0,0,1-.8,7,6,6,0,0,1-2.24,2.88,4.05,4.05,0,0,1-1.78.66,3.75,3.75,0,0,1-1.92-.17,5.52,5.52,0,0,1-2.57-2.64,17,17,0,0,1-1.26-3.3,44.51,44.51,0,0,1-1.09-13.79,62.2,62.2,0,0,1,2.37-13.61,49.78,49.78,0,0,1,5.57-12.65,34.41,34.41,0,0,1,9.44-10.09,30.74,30.74,0,0,1,12.83-5.06,38.44,38.44,0,0,1,13.78,0,41,41,0,0,1,12.89,4.81,54.11,54.11,0,0,1,10.9,8.37,60.1,60.1,0,0,1,8.65,10.64,60.5,60.5,0,0,0-8.82-10.47,54.39,54.39,0,0,0-11-8.12,40.6,40.6,0,0,0-12.77-4.61,37.74,37.74,0,0,0-13.53.09,30.85,30.85,0,0,0-12.47,5,33.72,33.72,0,0,0-9.16,9.87A49.12,49.12,0,0,0,600,542.47a62.3,62.3,0,0,0-2.28,13.41,43.83,43.83,0,0,0,1,13.48,15.62,15.62,0,0,0,1.18,3.1,4.66,4.66,0,0,0,2.07,2.23,3.19,3.19,0,0,0,1.46.12,3.35,3.35,0,0,0,1.4-.52,5.16,5.16,0,0,0,1.9-2.46,14,14,0,0,0,.76-6.53,21,21,0,0,0-1.73-6.47,19,19,0,0,0-3.71-5.56,16,16,0,0,0-5.48-3.77,18.27,18.27,0,0,0-13.16-.33A27.45,27.45,0,0,0,572.47,557a52.25,52.25,0,0,0-7.54,11.37A61.74,61.74,0,0,0,560.19,581.26Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M355.46,638.68a32.18,32.18,0,0,1,9.07-10.12,34.27,34.27,0,0,1,5.88-3.52,30.26,30.26,0,0,1,6.49-2.26,26.13,26.13,0,0,1,13.65.36,27.18,27.18,0,0,1,11.6,7.3,34.82,34.82,0,0,1,7.27,11.65,31.89,31.89,0,0,1,2.24,13.57,15.83,15.83,0,0,1-.67,3.45,7.9,7.9,0,0,1-1.76,3.12,4.8,4.8,0,0,1-3.35,1.51,7.46,7.46,0,0,1-3.53-.8,5.77,5.77,0,0,1-2.5-2.67,9.31,9.31,0,0,1-.77-3.5,20,20,0,0,1,1.16-6.87,41.36,41.36,0,0,1,6.68-12,48.71,48.71,0,0,1,9.9-9.55,40.43,40.43,0,0,1,12.33-6.08,34.74,34.74,0,0,1,13.68-1.15,35.19,35.19,0,0,1,13.07,4.16,35.86,35.86,0,0,1,10.42,8.88,48.53,48.53,0,0,1,6.9,11.8A57.7,57.7,0,0,1,477,659a57.86,57.86,0,0,0-4-13,49.17,49.17,0,0,0-7.07-11.58,35.16,35.16,0,0,0-10.33-8.63,34.95,34.95,0,0,0-26.2-2.73,39.51,39.51,0,0,0-12,6,47.6,47.6,0,0,0-9.67,9.4,41.23,41.23,0,0,0-6.51,11.74,18.87,18.87,0,0,0-1.14,6.53,8.43,8.43,0,0,0,.67,3.13,4.86,4.86,0,0,0,2.08,2.24,6.43,6.43,0,0,0,3.06.7,3.84,3.84,0,0,0,2.72-1.22,7.13,7.13,0,0,0,1.56-2.77,14.52,14.52,0,0,0,.63-3.24,30.93,30.93,0,0,0-2.15-13.18,34.43,34.43,0,0,0-7.05-11.4,26.6,26.6,0,0,0-11.22-7.19,25.54,25.54,0,0,0-13.33-.5,33.79,33.79,0,0,0-12.31,5.48A31.87,31.87,0,0,0,355.46,638.68Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M304,266.33a61.52,61.52,0,0,0-1.54-13.6,52.17,52.17,0,0,0-4.61-12.85,27.43,27.43,0,0,0-8.71-10.24,18.29,18.29,0,0,0-12.86-2.83,16,16,0,0,0-6.22,2.37,18.55,18.55,0,0,0-4.93,4.5,20.89,20.89,0,0,0-3.22,5.87,14,14,0,0,0-.83,6.53,5.17,5.17,0,0,0,1.26,2.84,3.41,3.41,0,0,0,1.24.84A3.09,3.09,0,0,0,265,250a4.69,4.69,0,0,0,2.55-1.67,15.37,15.37,0,0,0,1.88-2.73,43.56,43.56,0,0,0,4.2-12.85,62.31,62.31,0,0,0,1-13.56,48.82,48.82,0,0,0-2.3-13.36,33.51,33.51,0,0,0-6.55-11.77,30.61,30.61,0,0,0-10.91-7.85,37.76,37.76,0,0,0-13.12-3.32,40.74,40.74,0,0,0-13.49,1.43,53.89,53.89,0,0,0-12.59,5.27,60.4,60.4,0,0,0-11.07,8.06,60,60,0,0,1,10.94-8.27,54.5,54.5,0,0,1,12.58-5.53,41,41,0,0,1,13.67-1.59,38.4,38.4,0,0,1,13.4,3.25,30.68,30.68,0,0,1,11.24,8,34.44,34.44,0,0,1,6.76,12.05,49.64,49.64,0,0,1,2.4,13.61,63,63,0,0,1-1,13.78,44.51,44.51,0,0,1-4.36,13.13,15.82,15.82,0,0,1-2,2.9,5.49,5.49,0,0,1-3.12,2,4,4,0,0,1-1.91-.29,4.35,4.35,0,0,1-1.57-1.07,6.12,6.12,0,0,1-1.49-3.33,14.92,14.92,0,0,1,.89-7,22,22,0,0,1,3.38-6.11,18.27,18.27,0,0,1,11.71-7.09,19,19,0,0,1,13.33,3.06,27.87,27.87,0,0,1,8.79,10.54,52.74,52.74,0,0,1,4.42,13A62.14,62.14,0,0,1,304,266.33Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-14",
    d: "M348.06,639.16A9.42,9.42,0,1,0,354.2,651,9.42,9.42,0,0,0,348.06,639.16Zm5.05,11.47a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Zm-5.05-11.47A9.42,9.42,0,1,0,354.2,651,9.42,9.42,0,0,0,348.06,639.16Zm5.05,11.47a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Zm-5.05-11.47A9.42,9.42,0,1,0,354.2,651,9.42,9.42,0,0,0,348.06,639.16Zm5.05,11.47a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Zm-1.91-21.42a19.86,19.86,0,1,0,13,24.9A19.87,19.87,0,0,0,351.2,629.21Zm4.4,22.21a10.88,10.88,0,1,1-7.1-13.65A10.89,10.89,0,0,1,355.6,651.42Zm-1.4-.44a9.42,9.42,0,1,0-11.81,6.15A9.41,9.41,0,0,0,354.2,651Zm-1.09-.35a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Zm-5.05-11.47A9.42,9.42,0,1,0,354.2,651,9.42,9.42,0,0,0,348.06,639.16Zm5.05,11.47a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Zm-5.05-11.47A9.42,9.42,0,1,0,354.2,651,9.42,9.42,0,0,0,348.06,639.16Zm5.05,11.47a8.27,8.27,0,1,1-5.4-10.37A8.27,8.27,0,0,1,353.11,650.63Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "197.66 490.74 190.38 488.44 189.16 493.72 195.64 495.76 197.66 490.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "184.57 483.92 181.05 477.14 176.45 480.01 179.59 486.04 184.57 483.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "180.14 469.84 182.44 462.56 177.16 461.33 175.12 467.81 180.14 469.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "186.97 456.75 193.74 453.22 190.87 448.62 184.84 451.76 186.97 456.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "201.04 452.32 208.32 454.61 209.55 449.33 203.07 447.29 201.04 452.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "214.13 459.14 217.66 465.91 222.25 463.04 219.12 457.02 214.13 459.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "218.56 473.22 216.27 480.5 221.55 481.72 223.59 475.24 218.56 473.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-14",
    points: "211.74 486.31 204.97 489.83 207.84 494.43 213.86 491.29 211.74 486.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M715.4,575.86a30.35,30.35,0,1,0-42.46,6.28A30.36,30.36,0,0,0,715.4,575.86Zm-13-9.65a14.17,14.17,0,1,1-2.93-19.82A14.17,14.17,0,0,1,702.41,566.21Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "532.9 407.9 523.52 400.94 519.12 407.96 527.46 414.15 532.9 407.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "517.4 391.5 515.69 379.95 507.62 381.8 509.13 392.07 517.4 391.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "518.04 368.95 525 359.58 517.98 355.17 511.79 363.51 518.04 368.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "534.44 353.45 545.98 351.75 544.13 343.67 533.87 345.19 534.44 353.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "556.99 354.09 566.36 361.05 570.76 354.03 562.43 347.84 556.99 354.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "572.48 370.49 574.19 382.03 582.27 380.19 580.75 369.92 572.48 370.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "571.84 393.04 564.89 402.41 571.91 406.82 578.09 398.48 571.84 393.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "555.45 408.53 543.9 410.24 545.75 418.32 556.02 416.8 555.45 408.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M680.16,559.22l6.44,8.14,10.27-1.53,3.81-9.64-6.44-8.13L684,549.57Zm12.22-4.16a3.29,3.29,0,1,1-4.6.69A3.29,3.29,0,0,1,692.38,555.06Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M219.22,217.42a26.14,26.14,0,1,0-27.5,17.28A26.16,26.16,0,0,0,219.22,217.42Zm-12.43-8.6A12.24,12.24,0,0,1,189,219.61a12.22,12.22,0,1,1,17.75-10.79Z",
    transform: "translate(-145.48 -176.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "48.05 57.53 38.28 55.15 37.14 62.19 45.82 64.31 48.05 57.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "30.26 49.71 25.04 41.13 19.25 45.3 23.9 52.93 30.26 49.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "23.22 31.61 25.59 21.84 18.55 20.7 16.44 29.39 23.22 31.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "31.03 13.83 39.62 8.6 35.45 2.81 27.81 7.46 31.03 13.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "49.14 6.78 58.9 9.16 60.04 2.12 51.36 0 49.14 6.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "66.92 14.6 72.14 23.18 77.93 19.01 73.28 11.38 66.92 14.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "73.97 32.7 71.59 42.46 78.63 43.61 80.75 34.92 73.97 32.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "failure-cls-9",
    points: "66.15 50.48 57.56 55.7 61.73 61.49 69.37 56.85 66.15 50.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "failure-cls-9",
    d: "M186.44,213.51l7.83,4.29,7.64-4.65-.21-8.93-7.83-4.29-7.64,4.64Zm8.3-7.4a2.84,2.84,0,1,1-3.42,2.09A2.84,2.84,0,0,1,194.74,206.11Z",
    transform: "translate(-145.48 -176.71)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAssistantRobot);
export default __webpack_public_path__ + "static/media/error-assistant-robot.63da432bdc1ec7acf01bcf86eeecb4dc.svg";
export { ForwardRef as ReactComponent };